import * as Sentry from '@sentry/react'

/**
 * Filters out personally identifiable information (PII) from the Redux state
 * object using JSON.parse's reviver parameter.
 *
 * @param {Object} state Redux state object
 * @returns {Object} Filtered state object with PII data masked
 */
export const filterPii = (state) => {
  try {
    const filteredState = JSON.parse(JSON.stringify(state), (key, value) => {
      if (shouldFilter(key)) {
        return '[Filtered]'
      }
      return value
    })
    return filteredState
  } catch (error) {
    Sentry.captureException(error)
    return {
      error: 'Error filtering state',
    }
  }
}

/**
 * Determines if a key should be filtered.
 *
 * @param {string} key Key to check
 * @returns {boolean} True if the key should be filtered, false otherwise
 */
const shouldFilter = (key) => {
  const piiKeys = [
    'email',
    'estateSplitIssue',
    'firstName',
    'lastName',
    'name',
    'postal',
    'DOB',
    'preferredName',
    'fullLegalName',
    'addressLine1',
    'addressLine2',
    'phoneNumber',
    'postCode',
    'linkedUser',
    'details',
    'message',
  ]
  return piiKeys.includes(key)
}
